// extracted by mini-css-extract-plugin
module.exports = {"form":"JiraPasswordResetPage_form__2kV4n"};